import * as ambassadorWixDataV2Index from './data-v2-index-indexes.http.js';
import * as ambassadorWixDataV2IndexTypes from './data-v2-index-indexes.types.js';
import * as ambassadorWixDataV2IndexUniversalTypes from './data-v2-index-indexes.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createIndex(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2IndexUniversalTypes.CreateIndexRequest,
  ambassadorWixDataV2IndexTypes.CreateIndexRequest,
  ambassadorWixDataV2IndexUniversalTypes.CreateIndexResponse,
  ambassadorWixDataV2IndexTypes.CreateIndexResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Index.createIndex(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/indexes',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function dropIndex(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixDataV2IndexUniversalTypes.DropIndexRequest,
  ambassadorWixDataV2IndexTypes.DropIndexRequest,
  ambassadorWixDataV2IndexUniversalTypes.DropIndexResponse,
  ambassadorWixDataV2IndexTypes.DropIndexResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Index.dropIndex(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/indexes',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listIndexes(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV2IndexUniversalTypes.ListIndexesRequest,
  ambassadorWixDataV2IndexTypes.ListIndexesRequest,
  ambassadorWixDataV2IndexUniversalTypes.ListIndexesResponse,
  ambassadorWixDataV2IndexTypes.ListIndexesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV2Index.listIndexes(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/indexes',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableIndexes(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV2IndexUniversalTypes.ListAvailableIndexesRequest,
  ambassadorWixDataV2IndexTypes.ListAvailableIndexesRequest,
  ambassadorWixDataV2IndexUniversalTypes.ListAvailableIndexesResponse,
  ambassadorWixDataV2IndexTypes.ListAvailableIndexesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2Index.listAvailableIndexes(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/indexes/available',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Index as IndexOriginal,
  Order as OrderOriginal,
  OrderWithLiterals as OrderWithLiteralsOriginal,
  Field as FieldOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Failure as FailureOriginal,
  IndexSource as IndexSourceOriginal,
  IndexSourceWithLiterals as IndexSourceWithLiteralsOriginal,
  CreateIndexRequest as CreateIndexRequestOriginal,
  Environment as EnvironmentOriginal,
  EnvironmentWithLiterals as EnvironmentWithLiteralsOriginal,
  CreateIndexResponse as CreateIndexResponseOriginal,
  DropIndexRequest as DropIndexRequestOriginal,
  DropIndexResponse as DropIndexResponseOriginal,
  ListIndexesRequest as ListIndexesRequestOriginal,
  Paging as PagingOriginal,
  ListIndexesResponse as ListIndexesResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  ListAvailableIndexesRequest as ListAvailableIndexesRequestOriginal,
  ListAvailableIndexesResponse as ListAvailableIndexesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './data-v2-index-indexes.types.js';
